<template>
  <div class="user-form-centered">
    <div class="user-form">
      <h4 class="title">Sign in
        <small>All fields are required</small>
      </h4>
      <div class="alert alert-danger alert-dismissible fade show user-form-validation" role="alert"
           v-if="isError">
        <strong>{{error.title}}!</strong> {{error.message}}
      </div>
      <form>
        <div class="user-form-group">
          <input class="user-form-input" type="text" id="email" name="email" required
                 v-model="authData.email">
          <span class="bar"></span>
          <label for="email" class="user-form-label">Email</label>
        </div>
        <div class="user-form-group">
          <input class="user-form-input" type="password" name="password" id="password" required
                 v-model="authData.password">
          <span class="bar"></span>
          <label for="password" class="user-form-label">Password</label>
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="rememberMe"
                 v-model="authData.rememberMe">
          <label class="form-check-label" for="rememberMe">Remember me</label>
        </div>
      </form>
      <button class="btn btn-blue btn-login" v-on:click="signIn"
              :disabled="!isAuthDataValid || isLoading">
        <span class="spinner-border user-form-spinner" role="status" v-if="isLoading">
        </span>
        <span v-else>Login</span>
      </button>

      <div class="user-form-link">
        Not registered? <router-link to="/register">Create account!</router-link>
      </div>
    </div>
  </div>
</template>

<script>
    import {AUTH_REQUEST} from "../store/actions/auth";

    export default {
        name: "Login",
        data() {
            return {
                authData: {
                    email: null,
                    password: null,
                    rememberMe: false
                },
                error: {
                    title: null,
                    message: null
                }
            }
        },
        methods: {
            signIn() {
                this.$store.dispatch(AUTH_REQUEST, this.authData).then(() => {
                    this.$router.push('/profile');
                }).catch(e => {
                    console.log(e);
                    if (e.response) {
                        let errorData = e.response.data;

                        this.error = {
                            title: errorData.error_message,
                            message: errorData.inner_error.message
                        };
                    } else {
                        this.error = {
                            title: 'Network error',
                            message: e.message
                        };
                    }
                });
            }
        },
        computed: {
            isAuthDataValid: function () {
                return this.authData.email && this.authData.password;
            },
            isLoading() {
                return this.$store.getters.getAuthStatus === 'auth_loading'
            },
            isError() {
                return this.$store.getters.getAuthStatus === 'auth_error'
            }
        }
    }
</script>

<style scoped>

</style>
